export default "__VITE_ASSET__X_AVhb_l__"